module.exports = __webpack_public_path__ + "img/logo-wordpress.be8f81f2.png";